const AustriaFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="6.67" fill="#ED2939"/>
    <rect y="6.67" width="30" height="6.67" fill="#FFFFFF"/>
    <rect y="13.33" width="30" height="6.67" fill="#ED2939"/>
  </svg>
);

export default AustriaFlag;